import { ArrowDown, ArrowUp, Eye, EyeOff, GripVertical } from "lucide-react";

type Props = {
  id: string;
  title: string;
  visible: boolean;
  isEditMode: boolean;
  order: number;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onToggle: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
  children: React.ReactNode;
};

export function WidgetWrapper({
  title,
  visible,
  isEditMode,
  onMoveUp,
  onMoveDown,
  onToggle,
  canMoveUp = true,
  canMoveDown = true,
  children,
}: Props) {
  if (!isEditMode) {
    return visible ? <>{children}</> : null;
  }

  return (
    <div
      className="relative rounded-xl"
      style={{
        border: "1.5px dashed hsl(210,55%,75%)",
        padding: "6px",
        background: visible ? "transparent" : "hsl(210,30%,97%)",
      }}
    >
      <div
        className="mb-1.5 flex items-center gap-2 rounded-md px-2 py-1 text-[11px]"
        style={{
          background: "hsl(210,55%,95%)",
          color: "hsl(210,100%,28%)",
        }}
      >
        <GripVertical className="h-3.5 w-3.5 shrink-0" strokeWidth={1.5} />
        <span className="truncate font-medium uppercase tracking-wide">
          {title}
        </span>
        <div className="ml-auto flex items-center gap-1">
          <button
            type="button"
            onClick={onMoveUp}
            disabled={!canMoveUp}
            className="flex h-6 w-6 items-center justify-center rounded border bg-white disabled:opacity-40"
            style={{ borderColor: "hsl(210,55%,80%)" }}
            title="Move up"
          >
            <ArrowUp className="h-3 w-3" strokeWidth={1.5} />
          </button>
          <button
            type="button"
            onClick={onMoveDown}
            disabled={!canMoveDown}
            className="flex h-6 w-6 items-center justify-center rounded border bg-white disabled:opacity-40"
            style={{ borderColor: "hsl(210,55%,80%)" }}
            title="Move down"
          >
            <ArrowDown className="h-3 w-3" strokeWidth={1.5} />
          </button>
          <button
            type="button"
            onClick={onToggle}
            className="flex h-6 w-6 items-center justify-center rounded border bg-white"
            style={{ borderColor: "hsl(210,55%,80%)" }}
            title={visible ? "Hide widget" : "Show widget"}
          >
            {visible ? (
              <Eye className="h-3 w-3" strokeWidth={1.5} />
            ) : (
              <EyeOff className="h-3 w-3" strokeWidth={1.5} />
            )}
          </button>
        </div>
      </div>
      <div
        style={{
          opacity: visible ? 1 : 0.4,
          pointerEvents: "none",
        }}
      >
        {children}
      </div>
    </div>
  );
}
